// Circular-arrow icon for the turn buttons: which way the unit spins (screen directions).

import React from 'react';

export default function TurnIcon({ clockwise, size = 20 }: { clockwise: boolean; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ display: 'block' }}>
      <g transform={clockwise ? undefined : 'translate(24 0) scale(-1 1)'}>
        {/* A circle open at the top, running clockwise from the top right round to the top left,
            with the arrowhead on its leading end. */}
        <path d="M16 5.07 A8 8 0 1 1 5.87 6.86" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" />
        <path d="M8.6 3.6 L7.9 10.2 L2.4 5.2 Z" fill="currentColor" />
      </g>
    </svg>
  );
}
